import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injector, LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData} from '@angular/common';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AppInjector } from './app-injector.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpInterceptorService } from './auth/interceptors/http-interceptor-service';
import { TokenInterceptor } from './auth/interceptors/token.interceptor';
import { AuthService } from './auth/services/auth.service';
import { AppBreadcrumbService } from './core/containers/app-main-page/app.breadcrumb.service';
import { AppInsightsService } from './app-insights.service';
import { MenuService } from './core/services/app.menu.service';
import { SharedModule } from './shared/shared.module';
import esSV from '@angular/common/locales/es-SV';
import { AppMtMenuService } from './core/containers/app-main-page/app.mtmenu.service';
registerLocaleData(esSV);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    NgxWebstorageModule.forRoot({ prefix: 'buzz', separator: '.', caseSensitive: true }),
    BrowserAnimationsModule,
    AppRoutingModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(
      environment.prefix === 'test.' ? environment.firebaseConfig.test :
      environment.prefix === 'dev.' ? environment.firebaseConfig['development'] :
      environment.firebaseConfig.prod, 'angular-auth-firebase'
    ),
    AngularFirestoreModule,
    HttpClientModule,
    SharedModule,
  ],
  providers: [
    MenuService,
    AppBreadcrumbService,
    AppMtMenuService,
    AuthService,
    MessageService,
    ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-SV' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.injector = injector;
  }
}
